export default __webpack_public_path__ + "static/media/photo-1-dt.5e97d2a3.jpg";